import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavPrestationComponent } from './nav-prestation/nav-prestation.component';
import { RouterModule } from '@angular/router';

@NgModule({
	declarations: [NavPrestationComponent],
	imports: [RouterModule, CommonModule],
	exports: [NavPrestationComponent]
})
export class NavPrestationModule {}
